import { render, staticRenderFns } from "./loginAsWeChat.vue?vue&type=template&id=a2795496"
import script from "./loginAsWeChat.vue?vue&type=script&lang=js"
export * from "./loginAsWeChat.vue?vue&type=script&lang=js"
import style0 from "./loginAsWeChat.vue?vue&type=style&index=0&id=a2795496&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports